var map = {
	"./BeneficialOwnerDeclaration.pdf": [
		1018,
		25
	],
	"./FlatSalesAgreement.pdf": [
		1019,
		26
	],
	"./FlatSalesMandate.pdf": [
		1020,
		27
	],
	"./HouseSalesAgreement.pdf": [
		1021,
		28
	],
	"./HouseSalesMandate.pdf": [
		1022,
		29
	],
	"./LegalEntity.pdf": [
		1023,
		30
	],
	"./LegalEntityAgent.pdf": [
		1024,
		31
	],
	"./NaturalPerson.pdf": [
		1025,
		32
	],
	"./NaturalPersonAgent.pdf": [
		1026,
		33
	],
	"./RealPriceCertificate.pdf": [
		1027,
		34
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 968;
module.exports = webpackAsyncContext;